<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="QRVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
      center
      @close="closeDialog"
    >
      <div style="display: flex; justify-content: center">
        <div v-for="item in bankInfoList" :key="item.bankId">
          <div style="margin-top: 10px; display: flex">
            <div>
              <div
                style="text-align: center; font-size: 20px; margin-bottom: 10px"
              >
                {{ item.bankName }}
              </div>
              <img
                style="width: 300px"
                :src="item.imgPath"
                alt=""
                v-if="$shareType == 2"
              />
              <div
                :id="item.bankName"
                :ref="item.bankName"
                v-if="$shareType == 1"
              ></div>
              <div style="text-align: center; margin-top: 15px; color: #e6a23c">
                可点击鼠标右键保存后打印
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {
    dialogTitle: null,
    visible: Boolean,
    bankInfoList: Array,
  },
  data() {
    return {
      projectName: "",
      QRVisible: false,
      imgPath: "",
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {
    visible(val) {
      this.QRVisible = val;
    },
  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>